/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloorplanDto } from '../../models/floorplan-dto';
import { UpsertFloorplanDevicesDto } from '../../models/upsert-floorplan-devices-dto';

export interface FloorplanControllerUpsertDevices$Params {
  id: string;
  clientWorkspaceId: string;
      body: UpsertFloorplanDevicesDto
}

export function floorplanControllerUpsertDevices(http: HttpClient, rootUrl: string, params: FloorplanControllerUpsertDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
  const rb = new RequestBuilder(rootUrl, floorplanControllerUpsertDevices.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FloorplanDto>;
    })
  );
}

floorplanControllerUpsertDevices.PATH = '/api/floorplan/{clientWorkspaceId}/{id}/devices';
